export interface GridProps {
  children: React.ReactNode
}

export const Grid: React.FC<GridProps> = ({ children }) => (
  <div className="w-full grid xl:gap-8 lg:gap-6 md:gap-5 sm:gap-4 xs:gap-4 xs:grid-cols-9 md:grid-cols-12">
    {children}
  </div>
)
